import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "booking-view personal-data" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["title"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "space-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EasyDrop = _resolveComponent("EasyDrop")!
  const _component_InfoForm = _resolveComponent("InfoForm")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("header", null, [
        (_ctx.personalDataIndex === 0)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepHeadline']), 1))
          : (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepHeadlineMoreTravelers']), 1)),
        _createElementVNode("div", null, [
          (_ctx.personalDataIndex > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "back-btn",
                title: _ctx.pageTexts['hotelPageNavigationButtonPrevious'],
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeIndex(false)))
              }, null, 8, _hoisted_4))
            : (_ctx.bookingOverview.transfers.length)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: "back-btn",
                  title: _ctx.pageTexts['hotelPageNavigationButtonPrevious'],
                  to: { name: 'transfer', query: _ctx.query }
                }, null, 8, ["title", "to"]))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  class: "back-btn",
                  title: _ctx.pageTexts['hotelPageNavigationButtonPrevious'],
                  to: { name: 'departure', query: _ctx.query }
                }, null, 8, ["title", "to"])),
          (_ctx.pageTexts['hotelPagePersonalInformationStepInfoPopup'])
            ? (_openBlock(), _createBlock(_component_EasyDrop, {
                key: 3,
                dropdownType: 'tooltip',
                position: 'right'
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "rte",
                    innerHTML: _ctx.pageTexts['hotelPagePersonalInformationStepInfoPopup']
                  }, null, 8, _hoisted_5)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formPersons, (person, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (_ctx.personalDataIndex === index)
            ? (_openBlock(), _createBlock(_component_InfoForm, {
                key: 0,
                person: person,
                adultsCount: _ctx.adultsCount,
                childrenCount: _ctx.childrenCount,
                countries: _ctx.searchBookingOverview.countries,
                genders: _ctx.searchBookingOverview.genders,
                isContactPerson: person.isAdult && person.hotelRoomIndex === 0 && person.personIndex === 0,
                pageTexts: _ctx.pageTexts,
                localeStrings: _ctx.localeStrings,
                validateAllFields: _ctx.validateAllFields,
                onSetCurrentPersonValid: _ctx.setCurrentPersonValid
              }, null, 8, ["person", "adultsCount", "childrenCount", "countries", "genders", "isContactPerson", "pageTexts", "localeStrings", "validateAllFields", "onSetCurrentPersonValid"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.personalDataIndex < _ctx.formPersons.length - 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: _normalizeClass(["btn-primary", {'inactive': !_ctx.isCurrentPersonValid}]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeIndex(true)))
            }, _toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonNext']), 3))
          : (_ctx.isCurrentPersonValid)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: "btn-primary",
                to: { name: 'personal-data-overview', query: _ctx.query }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonNext']), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "btn-primary inactive",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validateFields && _ctx.validateFields(...args)))
              }, _toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonNext']), 1)),
        (_ctx.personalDataIndex > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              class: "prev",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeIndex(false)))
            }, _toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonPrevious']), 1))
          : (_ctx.bookingOverview.transfers.length)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 4,
                class: "prev",
                to: { name: 'transfer', query: _ctx.query }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonPrevious']), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 5,
                class: "prev",
                to: { name: 'departure', query: _ctx.query }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonPrevious']), 1)
                ]),
                _: 1
              }, 8, ["to"]))
      ])
    ])
  ]))
}